// extracted by mini-css-extract-plugin
module.exports = {"taxonomy":"TaxonomyTerms_taxonomy__dR_m_","termLinks":"TaxonomyTerms_termLinks__eYxF6"};